import projection from '../generated/pwr5d6f1.json';
import { AcceptanceManifest } from '../types';
export const pwr5d6f1AcceptanceManifest = projection as AcceptanceManifest;
